export class AutorizzazioneDTO {
  codice: string;
  nome: string;
}
